import { ref } from 'vue';

export type ComparisonFramingDiscoveryAnswer = 'someoneElseDrives' | 'iDrive' | 'uber' | 'busPublicTransit' | 'dontGoOutMuch' | 'other';

export type ComparisonFramingDiscoveryOption = {
  value: ComparisonFramingDiscoveryAnswer;
  label: string;
};

export const comparisonFramingDiscoveryOptions: ComparisonFramingDiscoveryOption[] = [
  {
    value: 'someoneElseDrives',
    label: 'Someone else drives me',
  },
  {
    value: 'iDrive',
    label: 'I drive myself',
  },
  {
    value: 'uber',
    label: 'I use the Uber app',
  },
  {
    value: 'busPublicTransit',
    label: 'I take the bus/public transportation',
  },
  {
    value: 'dontGoOutMuch',
    label: "I don't go out much",
  },
  {
    value: 'other',
    label: 'Other / no clear alternative',
  },
];

export const comparisonFramingDiscoveryAnswer = ref<ComparisonFramingDiscoveryAnswer | null>(null);

export const resetComparisonFramingState = () => {
  comparisonFramingDiscoveryAnswer.value = null;
};

export const selectComparisonFramingDiscoveryAnswer = (answer: ComparisonFramingDiscoveryAnswer) => {
  comparisonFramingDiscoveryAnswer.value = answer;
};
